import type { CoachingModal as Modal } from '@/core/state/appStore'
import type { VergabeStage } from './columns'

export type AufgabeKey =
  | 'aktivierung'
  | 'verbisHochladen'
  | 'lebenslaufHochladen'
  | 'eintrittsfragebogenAusfuellen'
  | 'teilnehmerakteGegenzeichnen'
  | 'empfangsbestaetigungUnterschreiben'
  | 'informationspflichtenUnterschreiben'
  | 'notfallkontaktAusfuellen'
  | 'einwilligungAusfuellen'
  | 'einwilligungUnterschreiben'
  | 'sicherheitsunterweisungUnterschreiben'
  | 'verbisJobboerseUnterschreiben'
  | 'potenzialanalyseAusfuellen'
  | 'klettHochladen'
  | 'gevaHochladen'
  | 'bewertungsbogenJobcoach'
  | 'bewertungsbogenFachanleiter'
  | 'bewertungsbogenSprachlehrkraft'
  | 'kompetenzbilanzierung'
  | 'foerderplanErstellen'
  | 'foerderplanUnterschreiben'
  | 'foerderplanGegenzeichnen'
  | 'erstberichtErstellen'
  | 'erstberichtUnterschreiben'
  | 'erstberichtGegenzeichnen'
  | 'anwesenheitErfassen'
  | 'zwischenberichtErstellen'
  | 'zwischenberichtBesprechen'
  | 'abschlussberichtErstellen'
  | 'abschlussberichtBesprechen'
  | 'abschlussberichtVerbisHochladen'
  | 'abgeschlossen'

export type AufgabeEntry = {
  dbName: string
  stage: VergabeStage
  position: number
  landing?: { modal: Modal; tab: string }
}

export const AUFGABE = {
  aktivierung: { dbName: 'Aktivierung', stage: 'aktivierung', position: 0 },
  verbisHochladen: { dbName: 'VerBIS-Screenshots hochladen', stage: 'verbis', position: 1 },
  lebenslaufHochladen: { dbName: 'Lebenslauf hochladen', stage: 'verbis', position: 2 },
  eintrittsfragebogenAusfuellen: { dbName: 'Eintrittsfragebogen ausfüllen', stage: 'teilnehmerakte', position: 3 },
  teilnehmerakteGegenzeichnen: { dbName: 'Teilnehmerakte gegenzeichnen', stage: 'teilnehmerakte', position: 4 },
  empfangsbestaetigungUnterschreiben: { dbName: 'Empfangsbestätigung unterschreiben lassen', stage: 'teilnehmerakte', position: 5 },
  informationspflichtenUnterschreiben: { dbName: 'Informationspflichten unterschreiben lassen', stage: 'teilnehmerakte', position: 6 },
  notfallkontaktAusfuellen: { dbName: 'Notfallkontakt ausfüllen', stage: 'teilnehmerakte', position: 7 },
  einwilligungAusfuellen: { dbName: 'Einwilligung ausfüllen', stage: 'teilnehmerakte', position: 8 },
  einwilligungUnterschreiben: { dbName: 'Einwilligung unterschreiben lassen', stage: 'teilnehmerakte', position: 9 },
  sicherheitsunterweisungUnterschreiben: { dbName: 'Sicherheitsunterweisung unterschreiben lassen', stage: 'teilnehmerakte', position: 10 },
  verbisJobboerseUnterschreiben: { dbName: 'Verbis- und Jobbörsennutzung unterschreiben lassen', stage: 'teilnehmerakte', position: 11 },
  potenzialanalyseAusfuellen: {
    dbName: 'Aufnahme- und Potenzialanalyse ausfüllen',
    stage: 'teilnehmerakte',
    position: 12,
    landing: { modal: 'aufnahme-potenzialanalyse', tab: 'form' },
  },
  klettHochladen: {
    dbName: 'Klett-Einstufungstest hochladen',
    stage: 'kompetenzfeststellung',
    position: 13,
    landing: { modal: 'kompetenzfeststellung', tab: 'klett' },
  },
  gevaHochladen: {
    dbName: 'GEVA-Test hochladen',
    stage: 'kompetenzfeststellung',
    position: 14,
    landing: { modal: 'kompetenzfeststellung', tab: 'geva' },
  },
  bewertungsbogenJobcoach: {
    dbName: 'Bewertungsbogen Jobcoach',
    stage: 'kompetenzfeststellung',
    position: 15,
    landing: { modal: 'kompetenzfeststellung', tab: 'jobcoach' },
  },
  bewertungsbogenFachanleiter: {
    dbName: 'Bewertungsbogen Fachanleiter',
    stage: 'kompetenzfeststellung',
    position: 16,
    landing: { modal: 'kompetenzfeststellung', tab: 'anleiter' },
  },
  bewertungsbogenSprachlehrkraft: {
    dbName: 'Bewertungsbogen Sprachlehrkraft',
    stage: 'kompetenzfeststellung',
    position: 17,
    landing: { modal: 'kompetenzfeststellung', tab: 'sprachlehrkraft' },
  },
  kompetenzbilanzierung: {
    dbName: 'Kompetenzbilanzierung',
    stage: 'kompetenzbilanzierung',
    position: 18,
    landing: { modal: 'kompetenzbilanzierung', tab: 'kompetenzbilanzierung' },
  },
  foerderplanErstellen: {
    dbName: 'Förderplan erstellen',
    stage: 'kompetenzbilanzierung',
    position: 19,
    landing: { modal: 'kompetenzbilanzierung', tab: 'foerderplan' },
  },
  foerderplanUnterschreiben: {
    dbName: 'Förderplan unterschreiben lassen',
    stage: 'kompetenzbilanzierung',
    position: 20,
    landing: { modal: 'kompetenzbilanzierung', tab: 'foerderplan' },
  },
  foerderplanGegenzeichnen: {
    dbName: 'Förderplan gegenzeichnen',
    stage: 'kompetenzbilanzierung',
    position: 21,
    landing: { modal: 'kompetenzbilanzierung', tab: 'foerderplan' },
  },
  erstberichtErstellen: {
    dbName: 'Erstbericht erstellen',
    stage: 'kompetenzbilanzierung',
    position: 22,
    landing: { modal: 'kompetenzbilanzierung', tab: 'erstbericht' },
  },
  erstberichtUnterschreiben: {
    dbName: 'Erstbericht unterschreiben lassen',
    stage: 'kompetenzbilanzierung',
    position: 23,
    landing: { modal: 'kompetenzbilanzierung', tab: 'erstbericht' },
  },
  erstberichtGegenzeichnen: {
    dbName: 'Erstbericht gegenzeichnen',
    stage: 'kompetenzbilanzierung',
    position: 24,
    landing: { modal: 'kompetenzbilanzierung', tab: 'erstbericht' },
  },
  anwesenheitErfassen: { dbName: 'Anwesenheit erfassen', stage: 'laufendeTeilnahme', position: 25 },
  zwischenberichtErstellen: { dbName: 'Zwischenbericht erstellen', stage: 'zwischenbericht', position: 26 },
  zwischenberichtBesprechen: { dbName: 'Zwischenbericht mit TN besprechen und unterschreiben', stage: 'zwischenbericht', position: 27 },
  abschlussberichtErstellen: { dbName: 'Abschlussbericht erstellen', stage: 'abschlussOffen', position: 28 },
  abschlussberichtBesprechen: { dbName: 'Abschlussbericht mit TN besprechen und unterschreiben', stage: 'abschlussOffen', position: 29 },
  abschlussberichtVerbisHochladen: { dbName: 'Abschlussbericht (Nord_F.5_II) in VerBIS hochladen', stage: 'abschlussOffen', position: 30 },
  abgeschlossen: { dbName: 'Abgeschlossen', stage: 'teilnahmeAbgeschlossen', position: 31 },
} satisfies Record<AufgabeKey, AufgabeEntry>
